import { SettingsAPI } from "api";
import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";

// Create context
const SettingsContext = createContext();

// Create Provider component
export const SettingsContextProvider = ({ children }) => {
  const [settingsData, setSettingsData] = useState([]); // Initialize with an empty object

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await SettingsAPI.get();
        setSettingsData(response?.data?.data || []); // Handle potential undefined values
      } catch (error) {
        console.error("Failed to fetch settings:", error);
      }
    };
    fetchSettings();
  }, []);

  const values = useMemo(() => [...settingsData], [settingsData]); // Include settings in the dependency array

  return (
    <SettingsContext.Provider value={values}>
      {children}
    </SettingsContext.Provider>
  );
};

// Custom hook for using context
export const useSettingContext = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error(
      "useSettingContext must be used within a SettingsContextProvider"
    );
  }
  return context;
};
